/* Product sales-trend card: swaps the visible period. */
(function () {
  'use strict';

  function setHidden(el, hide) {
    if (hide) {
      el.setAttribute('hidden', '');
      el.style.setProperty('display', 'none', 'important');
    } else {
      el.removeAttribute('hidden');
      el.style.removeProperty('display');
    }
  }

  function apply(card, period) {
    card.setAttribute('data-period', period);

    card.querySelectorAll('[data-ct-trend-view]').forEach(function (view) {
      setHidden(view, view.getAttribute('data-ct-trend-view') !== period);
    });

    card.querySelectorAll('[data-ct-trend-tab]').forEach(function (tab) {
      var active = tab.getAttribute('data-ct-trend-tab') === period;
      tab.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function init(card) {
    if (card.dataset.ctTrendReady === 'true') return;
    card.dataset.ctTrendReady = 'true';

    card.querySelectorAll('[data-ct-trend-tab]').forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        apply(card, tab.getAttribute('data-ct-trend-tab'));
      });
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-ct-trend]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:block:select', function (event) { scan(event.target); });
})();
